export const getNodeAsText = node => {
  return node.nodes
    .filter(node => node.type !== 'elementLabel')
    .map(text => text.text)
    .toArray()
    .join('\n')
}

export const sanitizeText = text => text.replace(/\r\n/g, '\n').trim()



// WEBPACK FOOTER //
// ./src/utils/helpers.js